import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Subprovider } from '@bitski/provider-engine';
/**
 * A subprovider that automatically populates missing transaction details.
 * This is needed because it has become common to submit transactions with
 * only some of the parameters and rely on the provider or node to fill in the rest.
 */

export var TransactionValidatorSubprovider = /*#__PURE__*/function (_Subprovider) {
  _inherits(TransactionValidatorSubprovider, _Subprovider);

  var _super = _createSuper(TransactionValidatorSubprovider);

  function TransactionValidatorSubprovider() {
    var _this;

    var minGasPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, TransactionValidatorSubprovider);

    _this = _super.call(this);
    _this.minGasPrice = minGasPrice;
    return _this;
  }

  _createClass(TransactionValidatorSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, _) {
      // Only handle transactions
      if (payload.method === 'eth_sendTransaction' || payload.method === 'eth_signTransaction') {
        this.populateTransactionFields(payload).then(function () {
          // Payload was modified. Continue.
          next();
        }).catch(function () {
          // Fall through if we cannot populate fields
          next();
        });
      } else {
        next();
      }
    } // Examine transaction and populate missing params

  }, {
    key: "populateTransactionFields",
    value: function () {
      var _populateTransactionFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var params, transaction, promises, accounts, values;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = payload.params || [];
                transaction = {};

                if (params.length > 0) {
                  transaction = params[0];
                }

                promises = []; // Populate missing from with default account

                if (!(transaction.from === undefined)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return this.getAccounts();

              case 7:
                accounts = _context.sent;
                transaction.from = accounts[0];

              case 9:
                // Populate missing gasPrice
                if (transaction.gasPrice === undefined) {
                  promises.push(this.estimateGasPrice());
                } else {
                  promises.push(transaction.gasPrice);
                } // Populate missing nonce


                if (transaction.nonce === undefined) {
                  promises.push(this.getNonce(transaction.from));
                } else {
                  promises.push(transaction.nonce);
                } // Populate missing gas


                if (transaction.gas === undefined) {
                  promises.push(this.estimateGas(transaction));
                } else {
                  promises.push(transaction.gas);
                } // Execute promises


                _context.next = 14;
                return Promise.all(promises);

              case 14:
                values = _context.sent;
                // Update parameters with loaded values. Must be very careful with the indexes here.
                transaction.gasPrice = values[0];
                transaction.nonce = values[1];
                transaction.gas = values[2]; // Set the params on the payload

                payload.params[0] = transaction;
                return _context.abrupt("return", payload);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function populateTransactionFields(_x) {
        return _populateTransactionFields.apply(this, arguments);
      }

      return populateTransactionFields;
    }()
  }, {
    key: "getNonce",
    value: function () {
      var _getNonce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(address) {
        var request;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                request = {
                  id: 0,
                  jsonrpc: '2.0',
                  method: 'eth_getTransactionCount',
                  params: [address, 'latest']
                };
                return _context2.abrupt("return", this.performRequest(request));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getNonce(_x2) {
        return _getNonce.apply(this, arguments);
      }

      return getNonce;
    }()
  }, {
    key: "getAccounts",
    value: function () {
      var _getAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var request;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                request = {
                  id: 0,
                  jsonrpc: '2.0',
                  method: 'eth_accounts',
                  params: []
                };
                return _context3.abrupt("return", this.performRequest(request));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: "estimateGas",
    value: function () {
      var _estimateGas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transaction) {
        var request;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                request = {
                  id: 0,
                  jsonrpc: '2.0',
                  method: 'eth_estimateGas',
                  params: [transaction]
                };
                return _context4.abrupt("return", this.performRequest(request));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function estimateGas(_x3) {
        return _estimateGas.apply(this, arguments);
      }

      return estimateGas;
    }()
  }, {
    key: "estimateGasPrice",
    value: function () {
      var _estimateGasPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var request;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request = {
                  id: 0,
                  jsonrpc: '2.0',
                  method: 'eth_gasPrice',
                  params: []
                };
                return _context5.abrupt("return", this.performRequest(request).then(function (gasPrice) {
                  if (gasPrice === '0x0') {
                    return "0x".concat(_this2.minGasPrice.toString(16));
                  }

                  return gasPrice;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function estimateGasPrice() {
        return _estimateGasPrice.apply(this, arguments);
      }

      return estimateGasPrice;
    }() // Wraps emitPayload in a promise

  }, {
    key: "performRequest",
    value: function performRequest(payload) {
      var _this3 = this;

      return new Promise(function (fulfill, reject) {
        _this3.emitPayload(payload, function (err, result) {
          if (err) {
            reject(err);
          } else {
            fulfill(result.result);
          }
        });
      });
    }
  }]);

  return TransactionValidatorSubprovider;
}(Subprovider);